module.exports = __webpack_public_path__ + "static/media/mm.4b5363f6.png";